import { FC } from 'react'
import { CheckIcon, RemoveIcon } from 'components/svg'

interface Props {
  value: boolean
}

const BooleanIcon: FC<Props> = ({ value }) =>
  value ? <CheckIcon /> : <RemoveIcon />

export default BooleanIcon
